/*
 * File: ClientColumnGrid.tsx
 * Project: a-a
 * File Created: Friday, 20th December 2024 11:49:04 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 25th July 2025 2:35:53 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box } from '@mui/material';
import React from 'react';
import CustomClientCard from './CustomClientCard';
import { Link } from 'react-router-dom';
import zeplinColor from '../../../theme/Color';

type Client = {
  Name: string;
  AccountId: string;
  closedDealAmount: string | null;
  openDealAmount: string | null;
  category: string | null;
};
type ClientData = {
  clients: Client[];
};

const ClientColumnGrid = ({
  clients,
  loading,
  category,
}: {
  clients: ClientData;
  loading: boolean;
  category: string | null;
}) => {
  return (
    <>
      <Box
        sx={{
          display: 'grid',
          // gridTemplateColumns: { xs: 'repeat(4, 1fr)', xl: 'repeat(5, 1fr)' },
          gridTemplateColumns: {
            xs: 'repeat(auto-fill, minmax(250px, 1fr))', // Responsive columns
            sm: 'repeat(auto-fill, minmax(270px, 1fr))',
            md: 'repeat(auto-fill, minmax(280px, 1fr))',
            lg: 'repeat(auto-fill, minmax(290px, 1fr))',
            xl: 'repeat(auto-fill, minmax(300px, 1fr))',
          },
          gap: '24px',
          overflowY: 'auto',
          gridAutoRows: 'min-content', // Make rows only as tall as content
          gridAutoFlow: 'row',
          // height: '65vh',
          height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 250px)' },
          alignItems: 'start',
          '& > a': {
            // Target all Link elements directly inside the grid
            height: 'auto',
            display: 'block',
          },
        }}
      >
        {loading
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((val) => (
              <CustomClientCard
                key={val}
                client={{
                  Name: '',
                  AccountId: '',
                  closedDealAmount: '',
                  openDealAmount: '',
                  category: '',
                }}
                loading={true}
              />
            ))
          : category && category === 'all'
          ? clients?.clients?.map((val: Client) => (
              <Link
                to={val.AccountId}
                state={{ client: val }}
                style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
              >
                {' '}
                <CustomClientCard key={val.AccountId} client={val} loading={loading} />
              </Link>
            ))
          : clients?.clients
              ?.filter((val) => val.category === category)
              .map((val: Client) => (
                <Link
                  to={val.AccountId}
                  state={{ client: val }}
                  style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                >
                  {' '}
                  <CustomClientCard key={val.AccountId} client={val} loading={loading} />
                </Link>
              ))}
      </Box>
    </>
  );
};

export default ClientColumnGrid;
